// NOTE: notes on each test card can be found here:
//       https://stripe.com/docs/terminal/testing#simulated-test-cards

// TODO: remove the ones not used in test environment
const simulatedCards = {
  chargeApproved: '4242424242424242',
  chargeApprovedDebit: '4000056655665556',
  chargeApprovedAmex: '378282246310005',
  chargeDeclined: '4000000000000002',
  chargeDeclinedInsufficientFunds: '4000000000009995',
  chargeDeclinedLostCard: '4000000000009987',
  chargeDeclinedStolenCard: '4000000000009979',
  chargeDeclinedExpiredCard: '4000000000000069',
  chargeDeclinedProcessingError: '4000000000000119',
}

export { simulatedCards }
